import type { ProductId } from '~~/shared/types/Products';
import { $Enums } from '@prisma/client';

export class ProductPrice {
  /**
   * Paddle product id
   */
  id: string;
  /**
   * perpetual - perpetual + 1year subscription updates & support
   */
  name: 'perpetual_only' | 'updates_1year' | 'subscription_1day' | 'subscription_1month' | 'subscription_1year';
  price: string;
  currency: string;
  type: 'recurring' | 'one_time';

  constructor(id: string,
              price: string,
              currency: string,
              name: ProductPrice['name'],
              type: ProductPrice['type'],
  ) {
    this.id = id;
    this.price = price;
    this.currency = currency;
    this.name = name;
    this.type = type;
  }

  get parsedPrice() {
    return parseFloat(this.price) / 100;
  }

  getParsedPriceWithCurrencyLocalized(locale: string) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: this.currency,
    }).format(this.parsedPrice);
  }
}

export class Product {
  id: ProductId;
  prices: ProductPrice[];
  paddleData: { paddleId: string };

  constructor(id: ProductId, prices: ProductPrice[], paddleData: { paddleId: string }) {
    this.id = id;
    this.prices = prices;
    this.paddleData = paddleData;
  }

  get productIdForDb(): $Enums.ProductId {
    return Product.productIdFromProductIdToDb(this.id);
  }

  getPriceByName(name: ProductPrice['name']) {
    return this.prices.find(price => price.name === name);
  }

  public static productIdFromDbToProductId(dbProductId: $Enums.ProductId): ProductId {
    return dbProductId.replaceAll('_', '-').toLowerCase() as ProductId;
  }

  public static productIdFromProductIdToDb(productId: ProductId): $Enums.ProductId {
    return productId.replaceAll('-', '_').toUpperCase() as $Enums.ProductId;
  }

  public static productIdToName(productId: ProductId): string {
    switch (productId) {
      case "wiresock-secure-connect":
        return 'Wiresock Secure Connect';
      case "wiresock-secure-connect-pro":
        return 'Wiresock Secure Connect Pro';
      case "wiresock-vpn-gateway":
        return 'Wiresock VPN Gateway';
      case "wiresock-vpn-gateway-pro":
        return 'Wiresock VPN Gateway Pro';
    }
    return '' as never;
  }
}
